import { PersonnelAdministration } from '@/api/index'

export function sectorInformation () {
  return PersonnelAdministration.request({
    method: 'post',
    url: '/SectorInformation'
  })
}
